import React, { ReactNode } from 'react';
import { Avatar, Badge } from 'antd';
import { BellOutlined } from '@ant-design/icons';
import styles from './CONotification.module.scss';
import {
  NotificationSizeEnums,
  NotificationStyleEnums,
} from 'enums/CONotificationEnums';

export interface CONotificationProps {
  children?: string | ReactNode;
  icon?: ReactNode;
  transparent?: boolean;
  count: number;
}
const CONotification: React.FC<CONotificationProps> = ({
  transparent,
  count,
}: CONotificationProps) => {
  return (
    <Badge count={count > 0 ? count : null} className={styles.badgeContainer}>
      {transparent ? (
        <Avatar
          style={{
            backgroundColor:
              NotificationStyleEnums.BACKGROUND_COLOR_TRANSPARENT,
            border: NotificationStyleEnums.BORDER,
            color: NotificationStyleEnums.COLOR,
          }}
          size={NotificationSizeEnums.LARGE}
          className={styles.avatarContainer}>
          {/* <p> */}
          <BellOutlined size={20} />
          {/* </p> */}
        </Avatar>
      ) : (
        <Avatar
          style={{
            backgroundColor: NotificationStyleEnums.BACKGROUND_COLOR,
            color: NotificationStyleEnums.COLOR,
          }}
          size={NotificationSizeEnums.LARGE}
          className={styles.avatarContainer}>
          {/* <p className={styles.bellIcon}> */}
          <BellOutlined />
          {/* </p> */}
        </Avatar>
      )}
    </Badge>
  );
};
export default CONotification;
